export enum CardPlaceholderType {
    CONTENT_CARD = 'ContentCard',
}
